import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { SignUpFormContext } from "../sign-up-form.context";
import { CheckboxComponent, TextLinkComponent, TypographyComponent } from "@gx1/gx-ui-common";

const SignUpFormOptions = () => {
  const { t } = useTranslation();
  const { termsPolicyAgreement, setTermsPolicyAgreement } = useContext(SignUpFormContext);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTermsPolicyAgreement(event.target.checked);
  };

  return (
    <CheckboxComponent
      isChecked={termsPolicyAgreement}
      onChange={handleChange}
      ariaLabel={t("Agree Terms")}
      label={
        <TypographyComponent styling={"metadata-lg"} element={"span"} boldness={"regular"}>
          {`${t("I agree to Gartner")} `}
          <TextLinkComponent
            href={"https://www.gartner.com/en/about/policies/terms-of-use"}
            onClick={() => window.open("https://www.gartner.com/en/about/policies/terms-of-use", "_blank")}
            text={t("Terms")}
            variant={"prominent"}
          />
          {` ${t("and")} `}
          <TextLinkComponent
            href={"https://www.gartner.com/en/about/policies/privacy"}
            onClick={() => window.open("https://www.gartner.com/en/about/policies/privacy", "_blank")}
            text={t("Privacy Policy")}
            variant={"prominent"}
          />
        </TypographyComponent>
      }
    />
  );
};

export default SignUpFormOptions;
